// Client-side implementation for chat API

export type ChatRole = 'user' | 'assistant' | 'system';
export type ChatPart = { text: string };
export type ChatContent = { role: ChatRole; content: string } | { role: ChatRole; parts: ChatPart[] };

export async function generateResponse(prompt: string, chatHistory: ChatContent[] = []): Promise<string> {
  try {
    console.log('Sending request to chat API with prompt:', prompt);
    console.log('Chat history length:', chatHistory.length);
    
    // Format messages for the API
    const messages = [
      ...chatHistory.map(msg => ({
        role: msg.role,
        content: 'content' in msg ? msg.content : 
                (Array.isArray(msg.parts) ? msg.parts[0]?.text || '' : '')
      })),
      {
        role: 'user' as const,
        content: prompt
      }
    ];

    const requestBody = { messages };
    
    console.log('Sending request to /api/chat');
    const response = await fetch('/api/chat', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ messages }),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      console.error('Chat API Error:', {
        status: response.status,
        statusText: response.statusText,
        error
      });
      throw new Error(error.message || 'Failed to get response from the server');
    }

    const responseData = await response.json();
    
    // Handle different response formats
    if (typeof responseData === 'string') {
      return responseData;
    } else if (responseData.choices && responseData.choices[0]?.message?.content) {
      return responseData.choices[0].message.content;
    } else if (responseData.text) {
      return responseData.text;
    }
    
    console.error('Unexpected response format:', responseData);
    return "I'm sorry, I couldn't generate a response. Please try again.";
  } catch (error: any) {
    console.error('Error in generateResponse:', {
      name: error.name,
      message: error.message,
      stack: error.stack,
      ...(error.response?.status && { status: error.response.status })
    });
    
    // Return a more detailed error message in development
    const errorMessage = process.env.NODE_ENV === 'development' 
      ? `Error: ${error.message || 'Unknown error'}`
      : "I'm having trouble connecting to the AI service. Please try again later.";
      
    return errorMessage;
  }
}
